import { DataModel } from 'common/models/utility-models/base-model';

export class FeedbackModel extends DataModel {
  title: string = '';
  categories: any[] = [];
  questions: any[] = [];
  // selected_category: any = '';
  // questionType: any = '';
  // Submit: any = '';
  // feedbackFormId: number = 1;
}




